import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["knob", "track", "label"]
  static values = { enabled: Boolean }

  connect() {
    this.submitting = false
  }

  toggle(event) {
    event.preventDefault()
    if (this.submitting) return

    // If the click came from the label (span), trigger the button instead
    if (event.target === this.labelTarget) {
      this.trackTarget.click()
      return
    }

    const form = this.trackTarget.closest("form")
    if (!form) return

    this.submitting = true

    const willBeEnabled = !this.enabledValue
    this.trackTarget.classList.toggle("bg-green-400", willBeEnabled)
    this.trackTarget.classList.toggle("bg-red-400", !willBeEnabled)
    this.knobTarget.classList.toggle("translate-x-5", willBeEnabled)
    this.knobTarget.classList.toggle("translate-x-0", !willBeEnabled)

    setTimeout(() => {
      form.requestSubmit()
      this.submitting = false
    }, 200)
  }
}
